module.exports = __webpack_public_path__ + "img/Tools & Equip_Unselected.c7416a6a.svg";